(function () {
    'use strict';

    angular
        .module('app')
        .controller('userTheme', ['$scope', 'plmThemes', function ($scope, plmThemes) {
            $scope.theme = plmThemes.getThemes();
            $scope.themeStyle = $scope.$root.theme;
        }])
        .controller('UserEditController', lController);

    function lController($scope, $rootScope, $state, $stateParams, cfpLoadingBar, UserService, RoleService, toaster, SearchHelpService, SearchFactory) {
        var model = this;

        $scope.currentUserId = $rootScope.userId;
        $scope.userId = $stateParams.userId;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }



        model.currentUserId = $rootScope.userId;
        model.userId = $stateParams.userId;
        model.editMode = (model.userId > 0);
        model.addMode = (model.userId <= 0);
        model.user = {};
        model.user.IsActive = "true";
        model.userRole = null;
        model.brandAssignment = [];
        model.roles = [];
        model.rolePermissions = [];
        model.user.Theme = [];
        model.UserEdit = false;

        model.getBrandById = function (k) {
            var brandName;
            angular.forEach(model.brandAssignment, function (key, value) {
                if (key.BrandId == parseInt(k)) {
                    brandName = key.BrandName;
                }
            });
            if (typeof brandName !== 'undefined') {
                return brandName.toLowerCase();
            }
        }

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 6) {
                if (userPermissionRow[1] == 2) {
                    model.UserEdit = true;
                }
            }
        });

        if (!model.UserEdit) {
            $state.go('permissionDenied');
        }

        model.PermissionsPredicate = ""; model.PermissionsReverse = false;
        model.PermissionsTableOrderby = function (predicate) {
            model.PermissionsReverse = model.PermissionsPredicate == predicate ? !model.PermissionsReverse : false;
            model.PermissionsPredicate = predicate;
        }

        if ($rootScope.GlobalSuccessMessage) {
            model.isMessage = true;
            model.confirmationMessage = $rootScope.GlobalSuccessMessage;
            $rootScope.GlobalSuccessMessage = "";
        }

        //New User Settings
        if (model.userId <= 0) {
            model.user.IsActive = true;
            model.user.ChangePasswordRequired = true;
        }

        model.validateFactory = function (userFactory, index) {
            if (!userFactory || !userFactory.FactNameKy || userFactory.FactNameKy.trim().length === 0)
                return;
            if ($rootScope.modalSearch && $rootScope.modalSearch.searchText == userFactory.FactNameKy)
                return;

            var searchText = { FactoryKey: userFactory.FactNameKy };

            SearchHelpService.searchFactories(searchText, 1, 99999, "FactoryKey", "ASC").then(function (factories) {
                if (factories.Results.length < 1) {
                    $scope.userForm.factoryForm.factoryName.$setValidity('invalid', false);
                    model.showError("No factories found that contain that text.");
                }
                else if (factories.Results.length == 1) {
                    userFactory.FactNameKy = factories.Results[0].FactoryKey;
                    $scope.userForm.factoryForm.factoryName.$setValidity('invalid', true);
                }
                else {
                    $rootScope.modalSearch = SearchFactory.factorySearch(function (item) {
                        userFactory.FactNameKy = item.FactoryKey;
                    });
                    $rootScope.modalSearch.parameters[0].value = userFactory.FactNameKy;
                    $rootScope.modalSearch.searchResults = $rootScope.modalSearch.map(factories);
                    $rootScope.modalSearch.showSearch();
                }
            });
        };

        model.onFactoryKeyKeyPress = function (evnt, userFactory) {
            if (evnt.keyCode === 13) {
                evnt.preventDefault();
                model.validateFactory(userFactory);
            }
        };

        function getGeneralUserInfo() {
            UserService.getUser(model.userId).then(function (response) {
                if (response) {
                    model.user = response;
                    var theme = model.user.Theme == null ? 0 : model.user.Theme
                    //set theme after getting response
                    model.themeStyle = theme;
                }
                else {
                    model.user = null;
                    model.showError('No Users Found');
                }

            },
            function (error, status) {
                model.user = null;
                model.showError('There was an error while retrieving user data. Please contact system administrator');
            });
        };

        function getUserFactories() {
            UserService.getUserFactories(model.userId).then(function (response) {
                if (response) {
                    //model.isErrorBrands = false;
                    model.userFactories = response;
                }
            },
            function (error, status) {
                model.showError('There was an error while retrieving user-factory data. Please contact system administrator');
            });
        };

        function getUsersBrands() {
            UserService.getUserBrandAssignmentForEditingUser(model.userId, model.currentUserId).then(function (response) {
                if (response) {
                    //model.isErrorBrands = false;
                    model.brandAssignment = response;
                }
                else {
                    model.showError('No brands found');
                }

            },
            function (error, status) {
                model.showError('There was an error while retrieving user-brand data. Please contact system administrator');
            });
        };

        function getRoles() {
            RoleService.getAllRoles().then(function (response) {
                if (response) {
                    //model.isErrorRole = false;
                    model.roles = response;
                }
                else {
                    model.showError('No roles found');
                }

            },
            function (error, status) {
                model.showError('There was an error while retrieving role data. Please contact system administrator');
            });
        };

        function getRolePermissions() {
            RoleService.getRolePermissions(model.userRole.RoleId).then(function (response) {
                if (response) {
                    //model.isErrorRole = false;
                    model.rolePermissions = response;
                }
                else {
                    model.showError('No permissions found for selected role');
                }

            },
            function (error, status) {
                model.showError('There was an error while retrieving permissions data. Please contact system administrator');
            });
        };

        function getUsersRole() {
            UserService.getUserRole(model.userId).then(function (response) {
                if (response) {
                    model.userRole = response;
                    getRolePermissions();
                }
                else {
                    model.showError('No role assigned to this user');
                }

            },
            function (error, status) {
                model.showError('There was an error while retrieving role data. Please contact system administrator');
            });
        };

        model.selectAll = function (e, val) {
            if (val) {
                angular.forEach(e, function (k, v) {
                    k.IsAssigned = true;
                })
            } else {
                angular.forEach(e, function (k, v) {
                    k.IsAssigned = false;
                })
            }
        }

        function doSave() {

            var userBindingModel = {};
            userBindingModel.User = model.user;
            userBindingModel.User.Email = model.user.UserName;
            userBindingModel.UserFactories = model.userFactories;
            userBindingModel.UserBrands = model.brandAssignment;
            userBindingModel.RoleId = model.userRole.RoleId;
            userBindingModel.IsActive = model.user.IsActive;
            userBindingModel.EmailConfirmed = model.user.EmailConfirmed;
            userBindingModel.ChangePasswordRequired = model.user.ChangePasswordRequired;
            userBindingModel.ResetPassword = model.ResetPassword;
            userBindingModel.networkId = model.user.networkId;

            if (model.editMode) {
                userBindingModel.User.Theme = model.user.Theme;
            }
            else {
                userBindingModel.User.Theme = 0;
            }

            if (model.editMode) {
                UserService.saveUser(userBindingModel)
                .then(function (response) {
                    getUserFactories();
                    getUsersBrands();
                    model.showSuccess('Record Saved Successfully.');
                    $scope.userForm.$setPristine();
                    $scope.userForm.$setUntouched();
                }, function (error, status) {
                    model.showError('There was an error while updating the user information. Please contact system administrator');
                    $scope.userForm.$setPristine();
                    $scope.userForm.$setUntouched();
                });
            }
            else if (model.addMode) {
                UserService.createUser(userBindingModel)
                .then(function (response) {
                    $scope.userForm.$setPristine();
                    $scope.userForm.$setUntouched();
                    model.showSuccess('Record Saved Successfully.');
                    $state.go("userEdit", { userId: response.Id });
                }, function (error, status) {
                    var toasterMsg;
                    if (error.ModelState) {
                        toasterMsg = 'The username ' + model.user.UserName + ' is in use!'
                    }


                    
                    model.showError(toasterMsg || 'There was an error while creating the user. Please contact system administrator.');
                    $scope.userForm.$setPristine();
                    $scope.userForm.$setUntouched();
                });
            }
        }

        function fireCustomValidation() {
            //clear
            model.customValidationValid = true;

            //at least one brand must be selected
            model.brandsNotValid = true;
            model.brandsNotValidMessage = "Please select at least one brand.";
            angular.forEach(model.brandAssignment, function (brandRow) {
                if (brandRow.IsAssigned) {
                    model.brandsNotValid = false;
                }
            });

            //check all issues
            if (model.brandsNotValid) {
                model.customValidationValid = false;
            }
        };

        model.AddFactory = function (userFactories, factoryKey) {
            userFactories.push({ UserFactoryId: 0, UserId: model.userId, FactNameKy: factoryKey, IsAssigned: true });
        };

        model.DelFactory = function (userFactory, userFactories) {
            var index = 0;
            for (var i = 0; i < userFactories.length; i++) {
                var factoryEntry = userFactories[i];
                if (factoryEntry.$$hashKey == userFactory.$$hashKey) {
                    index = i;
                }
            }
            userFactories[index].IsAssigned = false;
            //userFactories.splice(index, 1);
        };

        model.brandClicked = function (selBrand) {
            selBrand.IsAssigned = !selBrand.IsAssigned;
        };

        model.roleSelected = function () {
            if (!model.userRole.RoleId) {
                model.rolePermissions = [];
                return;
            }
            getRolePermissions();
        };

        model.themeSelected = function () {
            model.user.Theme = model.themeStyle;
            return;
        };

        model.Save = function (isFormInvalid) {
            fireCustomValidation();
            if (model.customValidationValid && !isFormInvalid) {
                doSave();
            }
            else {
                var theFormWithErrors = angular.element(document.querySelectorAll('.ng-invalid-required'));
                model.showError('Your submission contains error(s).  Please correct the highlighted items below.');
                //TODO: ng-touched on all controls.  This ensures proper styling of fields.
                angular.forEach($scope.userForm.$invalid, function (field) {
                    field.$setTouched();
                });
            }
        }

        //only try and load some data when in edit mode. no use in loading user info when adding a new user
        /*if (!model.addMode) {
            getGeneralUserInfo();
            getUsersRole();
        }
        getUserFactories();
        getUsersBrands();
        getRoles();*/

        model.showError = function (msg) {
            toaster.pop({ type: 'error', title: 'Error!', body: msg, timeout: 5000 });
        };

        model.showSuccess = function (msg) {
            toaster.pop({ type: 'success', title: 'Success!', body: msg, timeout: 5000 });
        };
    }
})();
